import React, { useEffect, useState } from "react";
import { Visibility, VisibilityOff } from "@material-ui/icons/";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { InputAdornment, IconButton } from "@material-ui/core/";
import { connect } from "react-redux";
import url from "../../constants/URL";
import "./buttonColor.css";
import Lottie from "react-lottie";
import animationData from "../../animations/676-done.json";
import Loading from "../Loading";

const RegisterDeliveryboyPage = (props) => {
  const [name, setName] = useState("");
  const [CNIC, setCNIC] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  useEffect(() => {
    if (error) {
      setError(null);
    }
  }, [phoneNumber, loginId]);

  function register() {
    setLoading(true);
    const data = {
      name,
      phoneNumber: `+92${phoneNumber}`,
      loginId: `${loginId}@vb.com`,
      password,
      CNIC,
      working: props.seller._id,
    };

    fetch(`${url}/register/deliveryboy`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.msg === "success") {
          setLoading(false);
          setDone(true);
        }
        if (
          response.msg === "Phone number already exists" ||
          response.msg === "Login Id already exists"
        ) {
          setLoading(false);
          setError(response.msg);
        }
      })
      .catch((e) => {
        setLoading(false);
        alert(e);
      });
  }

  if (loading) {
    return <Loading />;
  }

  const defaultOptions = {
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (done) {
    return (
      <div style={{ marginTop: 50 }}>
        <p style={{textAlign:'center',color:'dodgerblue',fontSize:22}}>Delivery boy registered successfully!</p>
        <Lottie options={defaultOptions} height={300} width={300} />
        <div style={{display:'flex',
            justifyContent:'center',
            marginTop:30,
            marginRight:35
      
      }}>
        <button
          onClick={() => props.history.push(`/dashboard/${props.seller._id}`)}
          style={{
            borderRadius: 20,
            alignItems: "center",
            fontSize: 20,
            padding: "12px 70px",
            color: "white",
            borderColor:'lawngreen',
            background:'lawngreen',
          }}
        >
          Ok
        </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div>
        <h3
          style={{
            background: "black",
            color: "white",
            borderRadius: "20px",
            margin: "20px 0 30px 0",
            padding: "20px",
            textAlign: "center",
          }}
        >
          Register Delivery Boy
        </h3>
        <ValidatorForm>
          <div style={{ margin: "10px 0" }}>
            <TextValidator
              onChange={(e) => setName(e.target.value)}
              value={name}
              name="name"
              label="Delivery Boy Name"
              variant="outlined"
              required
            />
          </div>
          <div style={{ margin: "10px 0" }}>
            <TextValidator
              onChange={(e) => {
                if (
                  /^[0-9\b]+$/.test(e.target.value) ||
                  e.target.value === ""
                ) {
                  setCNIC(e.target.value);
                }
              }}
              value={CNIC}
              name="CNIC"
              label="Enter CNIC Number"
              variant="outlined"
              required
            />
          </div>
          <div style={{ margin: "10px 0" }}>
            <TextValidator
              onChange={(e) => {
                if (
                  /^[0-9\b]+$/.test(e.target.value) ||
                  e.target.value === ""
                ) {
                  setPhoneNumber(e.target.value);
                }
              }}
              value={phoneNumber}
              name="phoneNumber"
              required
              label="Enter Phone Number"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <p>+92</p>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
          </div>
          <div style={{ margin: "10px 0" }}>
            <TextValidator
              onChange={(e) => setLoginId(e.target.value)}
              value={loginId}
              name="loginId"
              label="Login Id"
              variant="outlined"
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <p>@vb.com</p>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div style={{ margin: "10px 0" }}>
            <TextValidator
              className="input"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              label="Password"
              required
              name="password"
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
            <p style={{ fontStyle: "italic", color: "gray" }}>
              Remember these credentials, your delivery boy will need it to
              login.
            </p>
          </div>
          {(CNIC.length !== 13 && CNIC !== "") ||
          (name.length < 3 && name !== "") ||
          (phoneNumber.length !== 10 && phoneNumber !== "") ||
          (loginId.length < 6 && loginId !== "") ||
          (password.length < 6 && password !== "") ? (
            <p
              style={{
                backgroundColor: "rgb(255, 37, 79)",
                borderRadius: "20px",
                padding: "20px",
                color: "white",
              }}
            >
              {name.length < 3
                ? "Name is too short"
                : CNIC.length !== 13
                ? "CNIC number is not valid"
                : phoneNumber.length !== 10
                ? "Phone number is invalid"
                : loginId.length < 6
                ? "Login Id must have at least 6 characters"
                : password.length < 6 &&
                  "Password must have at least 6 characters"}
            </p>
          ) : (
            ""
          )}
          {error ? (
            <p
              style={{
                backgroundColor: "rgb(255, 37, 79)",
                borderRadius: "20px",
                padding: "20px",
                color: "white",
              }}
            >
              {error}
            </p>
          ) : (
            ""
          )}
          <button
            style={{
              borderRadius: 20,
              alignItems: "center",
              fontSize: 18,
              padding: 10,
              color: "white",
            }}
            className={
              CNIC.length !== 13 ||
              name.length < 3 ||
              phoneNumber.length !== 10 ||
              loginId.length < 6 ||
              password.length < 6
                ? "inactive"
                : "active"
            }
            disabled={
              CNIC.length !== 13 ||
              name.length < 3 ||
              phoneNumber.length !== 10 ||
              loginId.length < 6 ||
              password.length < 6
            }
            onClick={() => register()}
          >
            Register &#10140;
          </button>
        </ValidatorForm>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  seller: state.auth.seller,
});

export default connect(mapStateToProps)(RegisterDeliveryboyPage);
